import { axios } from "../lib";
import * as endpoints from "./apiEndpoints";

class ServiceService {
  static loadServices() {
    const url = `${endpoints.BASE_URL}${endpoints.SERVICES}`;
    return axios.get(url).then((response) => response.data);
  }

  static getService(id) {
    const url = `${endpoints.BASE_URL}${endpoints.SERVICES}/${id}`;
    return axios.get(url).then((response) => response.data);
  }

  static createService(service) {
    const url = `${endpoints.BASE_URL}${endpoints.SERVICES}`;
    const body = {
      service
    };

    return axios.post(url, body).then((response) => response.data);
  }

  static updateService(service) {
    const url = `${endpoints.BASE_URL}${endpoints.SERVICES}/${service.id}`;
    const body = {
      service
    };

    return axios.put(url, body).then((response) => response.data);
  }

  static createTask(id, task) {
    const url = `${endpoints.BASE_URL}${endpoints.SERVICES}/${id}/task`;
    const body = {
      task
    };

    return axios.post(url, body).then((response) => response.data);
  }

  static deleteTask(id, taskId) {
    const url = `${endpoints.BASE_URL}${endpoints.SERVICES}/${id}/task`;
    const body = {
      taskId
    };

    return axios.put(url, body).then((response) => response.data);
  }

  static findByCode(code) {
    const url = `${endpoints.BASE_URL}${endpoints.SERVICES}/search-code?code=${code}`;
    return axios.get(url).then((res) => res.data);
  }
}

export default ServiceService;
